function isFirstExecute (fn) {
  let firstTime = true
  return function () {
    if (firstTime) {
      firstTime = false
      return fn()
    }
    if (!firstTime) {
      return firstTime
    }
  }
}

export {isFirstExecute}



// WEBPACK FOOTER //
// ./src/common/util/isFirstExecute.js